import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  registroproduccionviajesdata: [],
};

const registroproduccionviajesSlice = createSlice({
  name: "registroproduccionviajes",
  initialState: initialState,
  reducers: {
    RegistroProduccionViajesData: (state, actions) => actions.payload,
    DeleteRegistroProduccionViajesData: (state = initialState, action) => {
      switch (action.type) {
        case "DELETE_ITEM":
          return {
            ...state,
            items: state.items.filter((item) => item.id !== action.payload),
          };
        default:
          return state;
      }
    },
    EmptyRegistroProduccionViajesData: () => initialState,
  },
});

export const {
  RegistroProduccionViajesData,
  UpdateRegistroProduccionViajesData,
  DeleteRegistroProduccionViajesData,
  EmptyRegistroProduccionViajesData,
} = registroproduccionviajesSlice.actions;

export default registroproduccionviajesSlice.reducer;
